import { StyleSheet } from "react-native";
import { Colors } from "../../../../theme";

export const styles = StyleSheet.create({
  loginButton: {
    backgroundColor: Colors.white,
  },
});
